module.exports = __webpack_public_path__ + "img/1F911.4bec417b.svg";